import React from 'react';
import { FORMATTER_DATA_TYPES, ALIGNMENT_CSS_CLASS } from './constants';

export default (column, colIndex, { sortElement, filterElement }) => {
    let classes = '';

    if (
        column.dataType === FORMATTER_DATA_TYPES.INTEGER ||
        column.dataType === FORMATTER_DATA_TYPES.FLOAT ||
        column.dataType === FORMATTER_DATA_TYPES.CURRENCY
    ) {
        classes = ALIGNMENT_CSS_CLASS.RIGHT;
    }

    if (column.text.length === 0) {
        column.text = <span>&nbsp;</span>;
    }

    return (
        <div className={classes}>
            {filterElement}
            {column.text}
            {sortElement}
        </div>
    );
};
